import React from 'react';
import { Route, Routes } from 'react-router-dom';
import EmsSub from './EMS/EmsSub';
import Emsmain from './EMS/EmsMain';
import EnergyMeter from './EMS/EnergyMeter';
import EMSGroups from './EMS/EmsGroups';
import SubGroup from './EMS/subgroup';
import EmsSubGroup from './EMS/EmsSubGroup';
import Reports from './EMS/Reports';
import Alerts from './EMS/Alerts';
import UsersGroups from './EMS/UsersGroups';
import Settings from './EMS/Settings';
import Groupportal from './EMS/Groupportal';
import PeakTimings from './EMS/PeakTimings';
import Productionreport from './EMS/Productionreport';
import Alertssettings from './EMS/Alertssettings';
import MachineList from './EMS/Machinelist';
import MachineGroups from './EMS/Machinegroups';
import ProductionDetails from './EMS/Productiondetails';
import AlertReports from './EMS/Alertreport';
import ReportCard from './EMS/Reportcard';
import ProtectedRoute from './ProtectedRoute';
import EnergyData from './EMS/EnergyData';
import Production from './EMS/ProductionMain';
import ProductionSub from './EMS/ProductionSub';
import Clocks from './EMS/clocks';
import FlowMeter from './EMS/FlowMeter';
import FlowGroups from './EMS/FlowGroup';
import FlowSub from './EMS/FlowSub';
import Flowportal from './EMS/flowportal';
import FlowSubGroup from './EMS/FlowSubGroup';
import ActualReading from './EMS/Actualreading';
import Products from './EMS/Products';
import ActualReadingportal from './EMS/ActualReadingportal';
import LevelMeter from './EMS/Waterlevelmeter';
import ActualReadingReports from './EMS/ActualReadingreport';
import Levelportal from './EMS/LevelPortal';
import Levelsub from './EMS/LevelSub';
import FlowReport from './EMS/FlowReport';
import LevelReport from './EMS/LevelReport';
import ProductionNextDetails from './EMS/ProductionNext';
import EnergySourcedata from './EMS/EnergySourcedata';
import ScheduleDetails from './EMS/Schedulereports';
import CustomDashboardPage from './EMS/Dashboard/CustomDashboardPage';
import UserGroup from './EMS/UserGroup';

const RoutesComponent = () => {
  return (
    <Routes>
      <Route path="/EMS/dashboard" element={<ProtectedRoute><Emsmain /></ProtectedRoute>} />
      <Route path="/EMS/custom-dashboard" element={<ProtectedRoute><CustomDashboardPage /></ProtectedRoute>} />
      <Route path="/EMS/emssub" element={<ProtectedRoute><EmsSub /></ProtectedRoute>} />
      <Route path="/EMS/EmsSubGroup" element={<ProtectedRoute><EmsSubGroup /></ProtectedRoute>} />
      <Route path="/EMS/energymeter" element={<ProtectedRoute><EnergyMeter /></ProtectedRoute>} />
      <Route path="/EMS/energydata" element={<ProtectedRoute><EnergyData /></ProtectedRoute>} />
      <Route path="/EMS/report" element={<ProtectedRoute><ReportCard /></ProtectedRoute>} />
      <Route path="/EMS/emsgroups" element={<ProtectedRoute><EMSGroups /></ProtectedRoute>} />
      <Route path="/EMS/group-portal" element={<ProtectedRoute><Groupportal /></ProtectedRoute>} />
      <Route path="/EMS/subgroup" element={<ProtectedRoute><SubGroup /></ProtectedRoute>} />
      <Route path="/EMS/machine" element={<ProtectedRoute><MachineList /></ProtectedRoute>} />
      <Route path="/EMS/groups" element={<ProtectedRoute><MachineGroups /></ProtectedRoute>} />
      <Route path="/EMS/productiondetails" element={<ProtectedRoute><ProductionDetails /></ProtectedRoute>} />
      <Route path="/EMS/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/EMS/productionreports" element={<ProtectedRoute><Productionreport /></ProtectedRoute>} />
      <Route path="/EMS/alertreports" element={<ProtectedRoute><AlertReports /></ProtectedRoute>} />
      <Route path="/EMS/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
      <Route path="/EMS/alertssettings" element={<ProtectedRoute><Alertssettings /></ProtectedRoute>} />
      <Route path="/EMS/usersgroups" element={<ProtectedRoute><UsersGroups /></ProtectedRoute>} />
      <Route path="/EMS/usergroup" element={<ProtectedRoute><UserGroup /></ProtectedRoute>} />
      <Route path="/EMS/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="/EMS/peaktimings" element={<ProtectedRoute><PeakTimings /></ProtectedRoute>} />
      <Route path='/EMS/production' element={<ProtectedRoute><Production /></ProtectedRoute>} />
      <Route path='/EMS/productionSub' element={<ProtectedRoute><ProductionSub /></ProtectedRoute>} />
      <Route path='/EMS/clocks' element={<ProtectedRoute><Clocks /></ProtectedRoute>} />
      <Route path='/EMS/flowmeter' element={<ProtectedRoute><FlowMeter /></ProtectedRoute>} />
      <Route path='/EMS/flowgroup' element={<ProtectedRoute><FlowGroups /></ProtectedRoute>} />
      <Route path='/EMS/flowsub' element={<ProtectedRoute><FlowSub /></ProtectedRoute>} />
      <Route path='/EMS/flowportal' element={<ProtectedRoute><Flowportal /></ProtectedRoute>} />
      <Route path='/EMS/FlowSubGroup' element={<ProtectedRoute><FlowSubGroup /></ProtectedRoute>} />
      <Route path='/EMS/Actualreading' element={<ProtectedRoute><ActualReading /></ProtectedRoute>} />
      <Route path='/EMS/Products' element={<ProtectedRoute><Products /></ProtectedRoute>} />
      <Route path='/EMS/ActualReadingportal' element={<ProtectedRoute><ActualReadingportal /></ProtectedRoute>} />
      <Route path='/EMS/Levelmeter' element={<ProtectedRoute><LevelMeter /></ProtectedRoute>} />
      <Route path='/EMS/Readingreport' element={<ProtectedRoute><ActualReadingReports /></ProtectedRoute>} />
      <Route path='/EMS/Levelportal' element={<ProtectedRoute><Levelportal /></ProtectedRoute>} />
      <Route path='/EMS/Levelsub' element={<ProtectedRoute><Levelsub /></ProtectedRoute>} />
      <Route path='/EMS/Flowreport' element={<ProtectedRoute><FlowReport /></ProtectedRoute>} />
      <Route path='/EMS/Levelreport' element={<ProtectedRoute><LevelReport /></ProtectedRoute>} />
      <Route path='/EMS/Productionnext' element={<ProtectedRoute><ProductionNextDetails /></ProtectedRoute>} />
      <Route path='/EMS/EnergySource' element={<ProtectedRoute><EnergySourcedata /></ProtectedRoute>} />
      <Route path='/EMS/Schedules' element={<ProtectedRoute><ScheduleDetails /></ProtectedRoute>} />
    </Routes>
  );
};

export default RoutesComponent;
